/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable sonarjs/no-duplicate-string */

import React, { Component } from 'react';

import Calendar from './Calendar';
import IntervalDates from './IntervalDates';
import SVGComponent from './SVG/SVGComponent';
import { SVG_ICONS } from '../constants';
import { generateQueryString } from '../utils/common';
import Dropdown from './Dropdown';


class Filter extends Component {
  constructor(props) {
    super(props);
    /**
     * @member {object}
     * @property {object} filter
     * @property {object} selectedItem Values of all dropdowns
     */
    this.defaultState = {
      filter: props.filters ? { ...props.filters } : {},
      selectedItem: props.selectedItem ? { ...props.selectedItem } : {},
      selectionsOpened: false,
    };
    this.state = { ...this.defaultState };
    /**
     * @member {boolean}
     * @description Clear search only when filter was changed
     */
    this.filteredBefore = false;
    this.filterLeagueName = this.props.isTennis ? 'filterCompetitions' : 'filterLeague';
  }

  componentDidMount() {
    this.clear();
    if (this.props.location.search && !this.props.preventBackFilterFunctionality) {
      this.extractFiltersFromUrl();
    } else if (this.props.initialApiCall) {
      this.search();
    }
    if (this.props.selectedItem) {
      this.setState({
        selectedItem: this.props.selectedItem ? { ...this.props.selectedItem } : {},
      });
    }
  }

  /**
   * Clear filter when section is changed
   *
   * @param {object} prevProp
   * @returns {void}
   */
  componentDidUpdate(prevProp) {
    if(prevProp.selectedItem !== this.props.selectedItem){
      this.setState({
        selectedItem: { ...this.props.selectedItem },
      });
    }
  }

  extractFiltersFromUrl = () => {
    const urlFilters = this.props.location.search;
    const extractedFilters = Object.fromEntries(new URLSearchParams(urlFilters));
    const filterLeagueArr = urlFilters?.split('&')?.filter((elem) => elem.startsWith(this.filterLeagueName))?.map((f) => parseInt(f.split('=')?.[1]));

    extractedFilters[`${this.filterLeagueName}[]`] = filterLeagueArr;
    extractedFilters.filterHideEndedMatches = parseInt(extractedFilters?.filterHideEndedMatches);

    this.setState({
      filter: extractedFilters,
      selectedItem: { 1: extractedFilters[`${this.filterLeagueName}[]`] },
    }, () => this.search());
  };

  /**
   * Search button
   *
   * @function
   * @returns {void}
   */
  search = () => {
    if (this.props.resetBeforeEachCall) this.props.resetData();
    const keys = Object.keys(this.state.filter);
    if (keys.length > 0 || this.props.allowEmpty === true) {
      this.filteredBefore = true;
      const filter = {...this.state.filter};
      const dateIntervalFilters = this.props.filterFields.find((f) => f?.dateInterval);
      keys.map((k) => {
        if (k === dateIntervalFilters?.field[0] || k === dateIntervalFilters?.field[1]) {
          filter[k] = this.state.filter[k].toString().replace(/ /g, 'T');
        }
      });
      this.props.setFilterData({ filter, callback: this.props.search });
      const params = generateQueryString(filter);

      if (this.props.eventsPage) {
        this.props.resetChosenRows();
      }
      this.props.navigate({
        pathname: this.props.location.pathname,
        search: params,
      });
    }
  };

  /**
   * Clear filter
   *
   * @function
   * @returns {void}
   */
  clear = () => {
    const filter = this.props.defaultFilter ? { ...this.props.defaultFilter }
      : this.props.filters ? { ...this.props.filters } : {};
    if (this.filteredBefore) {
      if (this.props.resetBeforeEachCall) this.props.resetData();
      this.filteredBefore = false;
      this.props.setFilterData({ filter, callback: this.props.search });
    }
    this.setState({
      filter,
      selectedItem: { 1: [] },
      selectionsOpened: false,
    });
    if (this.props.eventsPage) {
      this.props.resetChosenRows();
    }
    this.props.navigate({
      pathname: this.props.location.pathname,
      search: '',
    });
  };

  /**
   * Change filter input field
   *
   * @function
   * @param {string} fieldValue
   * @param {string | object} field
   * @param {number} [dropdownIndex]
   * @returns {void}
   */
  changeFilter = (fieldValue, field, dropdownIndex) => {
    const newFilter = {};
    const selectedItem = this.state.selectedItem;
    if (dropdownIndex !== undefined) {
      const f = field.dropdown.find((d) => d.label === fieldValue);
      const id = parseInt(f.id);
      newFilter[field.field] = id;
      selectedItem[dropdownIndex] = f;
    } else if (field?.field) {
      newFilter[field.field] = fieldValue;
    } else {
      newFilter[field] = fieldValue;
    }
    this.setState((prevState) => ({ ...prevState, filter: { ...prevState.filter, ...newFilter} }));
  };

  toggleSelectionDropdown = () => {
    this.setState({
      selectionsOpened: !this.state.selectionsOpened,
    });
  };

  toggleSelection = (field, i, selection) => {
    const selectedItems = [...this.state.selectedItem[i]];
    const index = selectedItems.findIndex((item) => item === selection);
    if (index === -1) {
      selectedItems.push(selection);
      const filter = {...this.state.filter};
      filter[field.field] = [...selectedItems];
      const tempSelectedItem = this.state.selectedItem;
      tempSelectedItem[i] = selectedItems;
      this.setState({ filter, selectedItem: tempSelectedItem });
    } else {
      this.removeSelection(field, i, selection, index);
    }
  };

  removeSelection = (field, i, selection, index) => {
    const selectedItems = [...this.state.selectedItem[i]];
    selectedItems.splice(index, 1);
    const filter = {...this.state.filter};
    filter[field.field] = [...selectedItems];
    const tempSelectedItem = this.state.selectedItem;
    tempSelectedItem[i] = selectedItems;
    this.setState({ filter, selectedItem: tempSelectedItem });
  };

  resetLeagueSelections = () => {
    const filters = {...this.state.filter};
    filters['filterLeague[]'] = [];
    this.setState({
      selectedItem: { 1: [] },
      filter: filters,
    });
  };

  renderSelectOptions = (field, i) => (
    <div
      className={`filter__field-input d-flex align-items-center hasDropdown ${this.state.selectionsOpened && 'open'}`}
      onClick={this.toggleSelectionDropdown}
    >
      {this.state.selectedItem[i]?.length === 0 && <span className="m-l-5">All</span>}
      <span className="filter__field-input-caret" />
      {this.state.selectedItem[i]?.map((item, index) => (
        <div className="filter__field-input-item" key={item}>
          <span>{field?.selections?.find((s) => parseInt(s.id) === parseInt(item))?.label}</span>
          <SVGComponent
            src={`${SVG_ICONS.utility}#close-sm`}
            className="close-btn m-l-5"
            onClick={this.removeSelection.bind(this, field, i, item, index)}
          />
        </div>
      ))}
      <div className="filter__field-input-list">
        <div
          className={`filter__field-input-list-item
             ${this.state.selectedItem[i].length === 0 && 'active'}`}
          onClick={this.resetLeagueSelections}
        >
          All
        </div>
        {field.selections.map((d) => (
          <div
            className={`filter__field-input-list-item
             ${this.state.selectedItem[i].find((item) => parseInt(item) === parseInt(d.id)) && 'active'}`}
            key={d.label}
            onClick={this.toggleSelection.bind(this, field, i, d.id)}
          >
            {d.label}
          </div>
        ))}
      </div>
    </div>
  );

  /**
   * Render checkbox filter
   *
   * @function
   * @param {object} field
   * @returns {view}
   */
  renderCheckbox = (field) => (
    <div className="filter__field" key={field.field}>
      <label className="filter__chk-box ended">
        <input
          id="checkbox_Filter"
          type="checkbox"
          checked={this.state.filter[field.field] ? 'checked' : ''}
          onChange={() => {
            this.changeFilter(this.state.filter[field.field] ? '' : 1, field.field);
          }}
          className="d-none"
        />
        <span className="filter__chk-box-label m-r-10">{field.text}</span>
        <div className="filter__chk-box-icon" />
      </label>
    </div>
  );

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <>
        <div className="filter">
          {this.props.filterFields.map((field, i) => (
            field.checkbox
              ? this.renderCheckbox(field)
              : (
                <div className="filter__field" key={field.text}>
                  <label className="filter__field-label">{field.text}</label>
                  {field.dateInterval
                    ? (
                      <IntervalDates
                        fields={field.field}
                        filter={this.state.filter}
                        defaultFilter={this.props.defaultFilter}
                        changeFilter={this.changeFilter}
                        selectedTimezone={this.props.selectedTimezone}
                        dateFilterFields={this.props.dateFilterFields}
                      />
                    )
                    : field.dateTime
                      ? (
                        <Calendar
                          field={field.field}
                          filter={this.state.filter}
                          defaultFilter={this.props.defaultFilter}
                          changeFilter={this.changeFilter}
                          className="p-l-15 p-r-15"
                          actions
                        />
                      )
                      : field.dropdown
                        ? (
                          <Dropdown
                            field={field}
                            index={i}
                            selectedItem={this.state.selectedItem}
                            changeFilter={this.changeFilter}
                          />
                        )
                        : field.selections
                          ? this.renderSelectOptions(field, i)
                          : field.type === 'number'
                            ? (
                              <input
                                type="number"
                                className="filter__field-input arrowDisabled"
                                id={field.field}
                                placeholder="-"
                                value={this.state.filter[field.field] || ''}
                                onChange={(e) => {
                                  this.changeFilter(e.target.value, field.field);
                                }}
                              />
                            )
                            : (
                              <input
                                type="text"
                                className="filter__field-input"
                                id={field.field}
                                placeholder="-"
                                value={this.state.filter[field.field] || ''}
                                onChange={(e) => {
                                  this.changeFilter(e.target.value, field.field);
                                }}
                              />
                            )}
                </div>
              )
          ))}
        </div>
        {this.props.info
          ? <div className="content__wrapper-info m-t-15">*selected Information will be displayed in the table(s) below</div>
          : <hr className="spacer-line grey m-t-15" />}
        <div className="d-flex justify-content-between align-items-center m-t-15">
          <div className="action-btn">
            <button type="button" id="searchBtn_Filter" className="btn btn-primary" onClick={this.search}>Search</button>
            <button type="button" id="clearFilters_Filter" className="btn btn-secondary" onClick={this.clear}>Clear Filters</button>
            {this.props.children}
          </div>
          {this.props.legend
            && (
              <div className="table-key">
                <div className="table-key__label">State Information</div>
                <div className="table-key__wrap">
                  <div className="table-key__item">
                    <span className="icon ended" />
                    {' '}
                    <span className="m-l-10">Ended</span>
                  </div>
                  <div className="table-key__item">
                    <span className="icon in-progress" />
                    {' '}
                    <span className="m-l-10">In Progress</span>
                  </div>
                  <div className="table-key__item">
                    <span className="icon prematch" />
                    {' '}
                    <span className="m-l-10">Pre Match</span>
                  </div>
                  {!this.props.isTennis && (
                    <div className="table-key__item">
                      <span className="icon skipped" />
                      {' '}
                      <span className="m-l-10">Skipped</span>
                    </div>
                  )}
                  <div className="table-key__item">
                    <span className="icon booked" />
                    {' '}
                    <span className="m-l-10">Booked</span>
                  </div>
                </div>
              </div>
            )}
        </div>
      </>
    );
  }
}
export default Filter;
